import { createStore } from 'owa-satcheljs';
import type { AccountKey } from 'owa-client-types';
import type { AccountOcpsPoliciesState } from './schema/OutlookCloudPoliciesSchema';

const getStore: () => Map<AccountKey, AccountOcpsPoliciesState> = createStore<
    Map<AccountKey, AccountOcpsPoliciesState>
>('ocpsPoliciesStore', new Map<AccountKey, AccountOcpsPoliciesState>());

export default getStore;
